module.exports = __webpack_public_path__ + "img/404.c4169e71.svg";